import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    CANCEL_SUBSCRIPTION: undefined,
    API: {
      CANCEL_SUBSCRIPTION: apiResourceActionCreator('subscription')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.post(`${USER_RESOURCE_ENDPOINT(RESOURCES.Subscription)}/cancel`, authToken, {}, actions.user.api.cancelSubscription)

export function* cancelSubscription() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'cancelSubscription',
  action: actions,
  sagas: cancelSubscription,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: {},
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/cancelSubscription.js